module.exports = __webpack_public_path__ + "static/media/stars.ed09cbd5.png";